export default __webpack_public_path__ + "static/media/get_paid.def2f638.png";